import dayjs from "dayjs";

// LWI-1655 - once an MSR has been sent to the TMS its content is locked. The
// API answers a locked write with 409 { code: "msr_locked", message, sentAt,
// sentBy } and GET msr/{id} carries locked / lockedAt / lockedBy.

export const MSR_LOCKED_CODE = "msr_locked";
export const MSR_LOCKED_FALLBACK =
  "This MSR was sent to LOGIKweb and is locked. It has been reloaded.";

/** Sections that stay editable (or actionable) after the send. */
export const LOCK_EXEMPT = new Set(["pp-customs-invoice", "pp-final-details"]);

export const isMsrLockedError = (error) =>
  error?.response?.status === 409 &&
  error.response.data?.code === MSR_LOCKED_CODE;

/** sentAt / lockedAt come as ISO-8601 with the UTC offset; shown in local time. */
export const formatSentAt = (value) => {
  if (!value) return "—";
  const d = dayjs(value);
  return d.isValid() ? d.format("YYYY-MM-DD HH:mm") : String(value);
};

/**
 * The refusal in the viewer's local time, built from sentAt (the server's own
 * message gives the time in UTC); the server message or fallback otherwise.
 */
export const msrLockedMessage = (error, fallback = MSR_LOCKED_FALLBACK) => {
  const data = error?.response?.data;
  if (data?.sentAt && dayjs(data.sentAt).isValid()) {
    return `This MSR was sent to LOGIKweb on ${formatSentAt(data.sentAt)} and is locked. It has been reloaded.`;
  }
  return data?.message || fallback;
};
